import React from 'react';
import { Form, Input, Tooltip } from '../../../../../components';
import { QuestionCircleOutlined } from '@ant-design/icons';

export const PasswordField = ({
    value,
    onChange,
    label = 'Password',
    placeholder,
    tooltip = 'Enter the password or secret key for authentication.',
    required = true,
    disabled = false,
    error,
}) => {
    return (
        <Form.Item
            label={
                <span>
                    {label}{' '}
                    <Tooltip title={tooltip}>
                        <QuestionCircleOutlined />
                    </Tooltip>
                </span>
            }
            validateStatus={error ? 'error' : ''}
            help={error}
            required={required}
        >
            <Input.Password
                value={value || ''}
                onChange={onChange}
                disabled={disabled}
                placeholder={placeholder || `Enter ${label} ${required ? '(required)' : '(optional)'}`}
            />
        </Form.Item>
    );
};
